import Button from 'apollo-react/components/Button';
import qs from 'query-string';
import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import BulkImportActionsMenu from '../../components/BulkImport/BulkImportActionsMenu';
import { WORKFLOW_STEP } from '../../constants/Urls';
import { useTranslation } from '../../custom-hooks/useTranslation';
import {
  checkManageRightByEntityName,
  getIsAddRecordButtonEnabled,
  getIsBulkImportEnabled,
} from '../../selectors/MasterSetupPageSelectors';
import { getUITA } from '../../utils/commonUtils';

const WorkflowMasterSetupTableActions = () => {
  const translateString = useTranslation();
  const history = useHistory();
  const location = useLocation();

  const showAddRecordButton = useSelector(getIsAddRecordButtonEnabled);
  const showBulkImportActions = useSelector(getIsBulkImportEnabled);

  const { entityName, entityViewName, containerWorkflowKey, workflowKey, stepId } = qs.parse(
    location.search
  );

  const hasManageRight = useSelector((state) =>
    checkManageRightByEntityName(state, { entityName })
  );

  return (
    <>
      {showAddRecordButton && hasManageRight && (
        <>
          {showBulkImportActions && (
            <BulkImportActionsMenu isWorkflowMasterSetup entityName={entityName} />
          )}
          <Button
            color="secondary"
            variant="secondary"
            ui-ta={getUITA('add-new-record')}
            onClick={() => {
              history.push(
                `${WORKFLOW_STEP}?${qs.stringify({
                  containerWorkflowKey,
                  entityType: entityName,
                  entityViewName: entityViewName || `V_${entityName}`,
                  stepId,
                  workflowKey,
                })}`
              );
            }}
          >
            {translateString('Add Record')}
          </Button>
        </>
      )}
    </>
  );
};

export default WorkflowMasterSetupTableActions;
